import InformesForm from "./Informe";
export default InformesForm;
